import { render, staticRenderFns } from "./Pattern.vue?vue&type=template&id=3899d0eb&scoped=true"
import script from "./Pattern.vue?vue&type=script&lang=js"
export * from "./Pattern.vue?vue&type=script&lang=js"
import style0 from "./Pattern.vue?vue&type=style&index=0&id=3899d0eb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3899d0eb",
  null
  
)

export default component.exports